/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Pit2_DInputs */

const en_diff_pit2_d = /** @type {(inputs: Diff_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a path holds the number 1 on the left and the string "1" on the right, or an object on one side and an array on the other, you get one tilde entry showing both values. The comparison does not descend into mismatched types, so you will not see a breakdown of what was inside the object that got replaced.`)
};

const ko_diff_pit2_d = /** @type {(inputs: Diff_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`한 경로가 왼쪽에서 숫자 1이고 오른쪽에서 문자열 "1"이거나, 한쪽이 객체이고 다른 쪽이 배열이면, 두 값을 함께 보여주는 물결표 항목 하나가 나옵니다. 타입이 어긋나면 안으로 내려가지 않으므로, 교체된 객체 안에 무엇이 있었는지에 대한 세부 내역은 보이지 않습니다.`)
};

const ja_diff_pit2_d = /** @type {(inputs: Diff_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あるパスが左で数値の 1、右で文字列の "1" である場合、または一方がオブジェクトで他方が配列である場合、両方の値を示すチルダ項目が 1 件出ます。型が食い違うと内部に降りないので、置き換えられたオブジェクトの中身の内訳は見えません。`)
};

/**
* | output |
* | --- |
* | "If a path holds the number 1 on the left and the string \"1\" on the right, or an object on one side and an array on the other, you get one tilde entry showing..." |
*
* @param {Diff_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_pit2_d = /** @type {((inputs?: Diff_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_pit2_d(inputs)
	if (locale === "ko") return ko_diff_pit2_d(inputs)
	return ja_diff_pit2_d(inputs)
});